export default function DataNotFound() {
    return (
        <p className="data-not-found">Brak danych</p>
    )
}